import controller from './remission.controller';
import templateBase from './templates/remission.view.html';
import adaptativo from './templates/remission-adaptativo.view.html';

let ReportRemissionComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate() {
  if(__env.adaptative){
    return adaptativo;
  } else {
    return templateBase;
  }
}



export default ReportRemissionComponent;



/** WEBPACK FOOTER **
 ** ./www/components/reports/remission/remission.component.js
 **/